import {defineStore} from 'pinia'
import API from '@/api'

const familyStore =  defineStore('familyConfig', {
    state: () => ({
        config:{
            userName: "",
            dataAuthTime:"",
            shareToken: "",
            registered: false
        },
        loading: false
    }),
    actions: {

        /**
         *
         * @param deviceId {string}
         * @returns {Promise<ResultDTO<FamilyClientConfig>>}
         */
        async getFamilyClientConfig(deviceId) {
            try {
                this.loading = true;
                const response = await API.family.getFamilyClientConfig(deviceId)
                if(response.success && response.data){
                    Object.assign(this.config, response.data)
                }else{
                    console.error('Error fetching users:', response);
                    this.loading = false;
                    return {success: false, data:null, errorMsg: 'error'}
                }

                return response;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching users:', error)
                return {success: false, data:null, errorMsg: 'error'}
            }finally {
                this.loading = false;
            }
        },
        /**
         *
         * @param config {FamilyClientConfig}
         * @returns {Promise<ResultDTO>}
         */
        async doSetFamilyClientConfig(config) {
            try {
                const response = await API.family.doSetFamilyClientConfig(config)

                if(response.success){
                    Object.assign(this.config, config)
                }else{
                    console.error('Error register users:', response);
                }

                return response;
            } catch (error) {
                console.error('Error fetching users:', error)
            }
        }
    },
});


export
{
    familyStore
}
